import script from "./CarrosselDeCategorias.vue?vue&type=script&setup=true&lang=js"
export * from "./CarrosselDeCategorias.vue?vue&type=script&setup=true&lang=js"

import "./CarrosselDeCategorias.vue?vue&type=style&index=0&id=72df9bfd&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72df9bfd"]])

export default __exports__